//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VRadioGroup, VRadio } from 'vuetify/lib';

export default {
  name: 'NsRadioGroup',
  components: {
    VRadio,
    VRadioGroup,
  },
  props: {
    /**
     * color of the radio button
     */
    color: {
      type: String,
      default: '#272525',
    },

    /**
     * Indicates whether the radio button is enabled/disabled
     */
    enabled: {
      type: Boolean,
      default: true,
    },

    /**
     * label of the radio group
     */
    label: {
      type: String,
      default: '',
    },

    /**
     * Name of the component
     */
    name: {
      type: String,
      default: '',
    },

    /**
     * Value of the component to be emitted when selected.
     */
    items: {
      type: Array,
      default: () => [],
    },

    size: {
      type: Number,
      default: 24,
    },

    /**
     * Value of the model
     */
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
  },
  mounted() {
    // set the default value since the mandatory option is not working
    this.value = this.$props.items[0].value;
    this.$emit('input', this.value);
  },
  methods: {
    emitChange(value) {
      this.$emit('input', value);
    },
  },
};
